import { takeLatest, put, all, call } from "redux-saga/effects";
import actionTypes from "./actionTypes";
import {
  createRequestData,
  formatCurrencyData,
  getResponseData,
} from "../../utils/index";
import Server, { requestERPLYData } from "../../api/Server";

export function* fetchProductGroups({
  payload: { pimBaseUrl, sessionKey, clientCode },
}) {
  try {
    const response = yield call(
      Server.getProductGroupsIndented,
      pimBaseUrl,
      clientCode,
      sessionKey
    );

    yield put({
      type: actionTypes.GET_PRODUCT_GROUP_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: actionTypes.GET_PRODUCT_GROUP_FAILED });
  }
}

export function* onFetchProductGroupsStart() {
  yield takeLatest(actionTypes.GET_PRODUCT_GROUP_START, fetchProductGroups);
}

export function* fetchProductCategories({
  payload: { pimBaseUrl, sessionKey, clientCode },
}) {
  try {
    const response = yield call(
      Server.getProductCategoriesIndented,
      pimBaseUrl,
      clientCode,
      sessionKey
    );

    yield put({
      type: actionTypes.GET_PRODUCT_CATEGORY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: actionTypes.GET_PRODUCT_CATEGORY_FAILED });
  }
}

export function* onFetchProductCategoriesStart() {
  yield takeLatest(
    actionTypes.GET_PRODUCT_CATEGORY_START,
    fetchProductCategories
  );
}

export function* fetchBrands({
  payload: { sessionKey, clientCode, isIframe, lang },
}) {
  const request = {
    clientCode,
    request: "getBrands",
    sendContentType: 1,
    lang,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: actionTypes.GET_BRAND_FAILED,
      });
    } else {
      yield put({
        type: actionTypes.GET_BRAND_SUCCESS,
        payload: response.data.records,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.GET_BRAND_FAILED });
  }
}

export function* onFetchBrandsStart() {
  yield takeLatest(actionTypes.GET_BRAND_START, fetchBrands);
}

export function* fetchSuppliers({
  payload: { sessionKey, clientCode, isIframe },
}) {
  const request = {
    requests: createRequestData(50, {
      requestName: "getSuppliers",
      recordsOnPage: 100,
      sendContentType: 1,
    }),
    clientCode,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: actionTypes.GET_SUPPLIER_FAILED,
      });
    } else {
      yield put({
        type: actionTypes.GET_SUPPLIER_SUCCESS,
        payload: getResponseData(response.data.requests),
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.GET_SUPPLIER_FAILED,
    });
  }
}

export function* onFetchSupplierStart() {
  yield takeLatest(actionTypes.GET_SUPPLIER_START, fetchSuppliers);
}

export function* fetchCustomers({
  payload: { crmBaseUrl, sessionKey, clientCode },
}) {
  try {
    const response = yield call(
      Server.getCustomers,
      crmBaseUrl,
      clientCode,
      sessionKey
    );
    yield put({
      type: actionTypes.GET_CUSTOMERS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.GET_CUSTOMERS_FAILED,
    });
  }
}

export function* onFetchCustomerStart() {
  yield takeLatest(actionTypes.GET_CUSTOMERS_START, fetchCustomers);
}

export function* fetchCurrency({
  payload: { sessionKey, clientCode, isIframe, lang },
}) {
  const request = {
    clientCode,
    request: "getCurrencies",
    sendContentType: 1,
    lang,
  };

  if (isIframe || sessionKey) {
    request.sessionKey = sessionKey;
  }

  try {
    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: actionTypes.GET_CURRENCY_FAILED,
      });
    } else {
      yield put({
        type: actionTypes.GET_CURRENCY_SUCCESS,
        payload: formatCurrencyData(response.data.records),
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.GET_CURRENCY_FAILED });
  }
}

export function* onFetchCurrencyStart() {
  yield takeLatest(actionTypes.GET_CURRENCY_START, fetchCurrency);
}

export function* sagas() {
  yield all([
    call(onFetchProductGroupsStart),
    call(onFetchProductCategoriesStart),
    call(onFetchBrandsStart),
    call(onFetchSupplierStart),
    call(onFetchCustomerStart),
    call(onFetchCurrencyStart),
  ]);
}
